export default __webpack_public_path__ + "static/media/sort.78150125.svg";